<!-- Gráficos de línea con Chart.js - agrupados por días laborables y fin de semana -->
<div class="charts-container position-relative">

  <!-- DÍAS ENTRE SEMANA -->
  <div class="weekdays-group mb-2 mt-4">



    <div *ngFor="let day of daysOfWeek" >
        <div class="day-row"   [ngClass]="{' pt-4': day.index === 5 }">
            <div class="day-label">
              <span class="d-flex flex-column align-items-center">
                <span class="day-label-text">{{ day.short }}</span>

                <span *ngIf="getDayBadgePeriods(day).length > 0" class="day-period-stack mt-1" [class.day-period-stack--double]="getDayBadgePeriods(day).length > 1">
                  <span
                    class="rounded-circle text-white d-flex align-items-center justify-content-center small lh-1 day-period-badge day-period-badge--primary"
                    [ngClass]="getPeriodBadgeClass(getDayBadgePeriods(day)[0])"
                  >{{ getDayBadgePeriods(day)[0] }}</span>

                  <span
                    *ngIf="getDayBadgePeriods(day).length > 1"
                    class="rounded-circle text-white d-flex align-items-center justify-content-center small lh-1 day-period-badge day-period-badge--secondary"
                    [ngClass]="getPeriodBadgeClass(getDayBadgePeriods(day)[1])"
                  >{{ getDayBadgePeriods(day)[1] }}</span>
                </span>
              </span>
            </div>
            <div class="day-chart">
              <canvas [id]="chartIdPrefix + '-' + day.index" [style.height]="(day.index === 4 || day.index === 6) ? '90px' : '80px'"></canvas>
            </div>
          </div>

    </div>


    <!-- Lunes -->
    <!-- <div class="day-row">
      <div class="day-label">
        <span class="day-label-text">L</span>
      </div>
      <div class="day-chart">
        <canvas [id]="chartIdPrefix + '-0'" style="height: 85px;"></canvas>
      </div>
    </div> -->

    <!-- Martes -->
    <!-- <div class="day-row">
      <div class="day-label">
        <span class="day-label-text">M</span>
      </div>
      <div class="day-chart">
        <canvas [id]="chartIdPrefix + '-1'" style="height: 85px;"></canvas>
      </div>
    </div> -->

    <!-- Miércoles -->
    <!-- <div class="day-row">
      <div class="day-label">
        <span class="day-label-text">X</span>
      </div>
      <div class="day-chart">
        <canvas [id]="chartIdPrefix + '-2'" style="height: 85px;"></canvas>
      </div>
    </div> -->

    <!-- Jueves -->
    <!-- <div class="day-row">
      <div class="day-label">
        <span class="day-label-text">J</span>
      </div>
      <div class="day-chart">
        <canvas [id]="chartIdPrefix + '-3'" style="height: 85px;"></canvas>
      </div>
    </div> -->

    <!-- Viernes -->
    <!-- <div class="day-row">
      <div class="day-label">
        <span class="day-label-text">V</span>
      </div>
      <div class="day-chart">
        <canvas [id]="chartIdPrefix + '-4'" style="height: 95px;"></canvas>
      </div>
    </div>
  </div> -->

  <!-- FIN DE SEMANA -->
  <!-- <div class="weekend-group"> -->
    <!-- Sábado -->
    <!-- <div class="day-row">
      <div class="day-label">
        <span class="day-label-text weekend">S</span>
      </div>
      <div class="day-chart">
        <canvas [id]="chartIdPrefix + '-5'" style="height: 85px;"></canvas>
      </div>
    </div> -->

    <!-- Domingo -->
    <!-- <div class="day-row">
      <div class="day-label">
        <span class="d-flex flex-column align-items-center">
          <span class="day-label-text weekend">D</span>
          <span class="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center mt-1 small" style="width: 1.5em; height: em;">P1</span>
        </span>
      </div>
      <div class="day-chart">
        <canvas [id]="chartIdPrefix + '-6'" style="height: 95px;"></canvas>
      </div>
    </div> -->
  </div>

  <div *ngIf="chartHoverTooltip.visible && chartHoverTooltip.kind === 'cycle' && chartHoverTooltip.cycle"
    class="scheduler-chart-tooltip position-absolute shadow-sm rounded-2 border bg-white text-dark small px-3 py-2"
    [style.left.px]="chartHoverTooltip.x"
    [style.top.px]="chartHoverTooltip.y"
    role="tooltip">
    <div class="scheduler-chart-tooltip__title fw-semibold mb-1">{{ 'programKind_cycle' | translate }}</div>
    <div class="scheduler-chart-tooltip__line">
      {{ 'holidayStart' | translate }}: {{ chartHoverTooltip.cycle.startTime }} · {{ 'holidayEnd' | translate }}: {{ chartHoverTooltip.cycle.endTime }}
    </div>
    <div class="scheduler-chart-tooltip__line scheduler-chart-tooltip__line--duration">
      <span class="scheduler-chart-tooltip__label">{{ 'on' | translate }}:</span> {{ chartHoverTooltip.cycle.onLabel }}
      <span class="scheduler-chart-tooltip__sep">·</span>
      <span class="scheduler-chart-tooltip__label">{{ 'off' | translate }}:</span> {{ chartHoverTooltip.cycle.offLabel }}
    </div>
  </div>

  <div *ngIf="chartHoverTooltip.visible && chartHoverTooltip.kind === 'pulse' && chartHoverTooltip.pulse"
    class="scheduler-chart-tooltip position-absolute shadow-sm rounded-2 border bg-white text-dark small px-3 py-2"
    [style.left.px]="chartHoverTooltip.x"
    [style.top.px]="chartHoverTooltip.y"
    role="tooltip">
    <div class="scheduler-chart-tooltip__title fw-semibold mb-1">{{ 'programKind_pulse' | translate }}</div>
    <div class="scheduler-chart-tooltip__line">
      {{ 'holidayStart' | translate }}: {{ chartHoverTooltip.pulse.startTime }}
    </div>
    <div class="scheduler-chart-tooltip__line scheduler-chart-tooltip__line--duration">
      <span class="scheduler-chart-tooltip__label">{{ 'duration' | translate }}:</span> {{ chartHoverTooltip.pulse.durationLabel }}
    </div>
  </div>

  <!-- Leyenda y datos astronómicos -->
  <div *ngIf="showLegend" class="legend-container mt-2">
    <div class="d-flex justify-content-center align-items-center">
      <!-- Leyenda ON -->
      <div class="legend-item me-4">
        <div class="legend-color on-state"></div>
        <span class="legend-text">{{ 'on' | translate }}</span>
      </div>

      <!-- Datos de orto y ocaso -->
      <div class="sun-data">
        <div class="d-flex align-items-center">
          <div class="sun-item me-3">
            <i class="fas fa-sun text-warning me-1"></i>
            <span class="sun-label">{{ 'sunrise' | translate }} ({{ 'today' | translate }}):</span>
            <span class="sun-time">{{getOrtoTimeForDay( getDayOfWeek() )}}</span>
          </div>
          <div class="sun-item">
            <i class="fas fa-moon text-muted me-1"></i>
            <span class="sun-label">{{ 'sunset' | translate }} ({{ 'today' | translate }}):</span>
            <span class="sun-time">{{getOcasoTimeForDay( getDayOfWeek() )}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--  -->
